import type { Ref } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import capitalMarketsService from '../services/capitalMarketsService';

export default function useFinancingDetail(financingId: Ref<number>) {
  return useQuery({
    enabled: () => Boolean(financingId.value),
    queryFn: () => capitalMarketsService.getFinancingDetail({ financing_id: financingId.value }),
    queryKey: ['financing', 'detail', financingId],
  });
}
